<template>
    <auth-layout>
        <div class="columns">
            <div class="column is-6 is-offset-3 is-4-widescreen is-offset-4-widescreen">
                <div class="box">
                    <form @submit.prevent="onLogin">
                        <form-input label="Correo electrónico" holder="email@mail.com" :error="errors.email" v-model="user.email"></form-input>
                        <form-input label="Contraseña" type="password" reveal holder="●●●●●●●" :error="errors.password" v-model="user.password"></form-input>
                        <div class="field">
                            <button class="button is-primary is-fullwidth" type="submit">
                                Iniciar
                            </button>
                        </div>
                        <p class="has-text-centered">
                            <router-link :to="{name:'ForgotPassword'}">¿Olvidé mi contraseña?</router-link>
                        </p>
                    </form>
                </div>
            </div>
        </div>

    </auth-layout>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                user: {},
                errors: {}
            }
        },
        methods: {
            async onLogin() {
                this.errors = {};
                this.$loader.show();
                this.$auth.login({
                    data: this.user,
                    success() {
                        this.$loader.hide();
                    },
                    error(error) {
                        this.$loader.hide();
                        let data = error.response.data || {};
                        this.errors = data.errors || {};
                        this.$notify.danger(data.message);
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
